import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { MunicipalityView } from '@app/shared/services/api/municipality.service';
import { cssVariables } from '@env/css-vars';
import { isNil } from 'lodash';
import { OrphanMunicipalityDialogComponent } from '../../dialog/orphan-municipality-dialog/orphan-municipality-dialog.component';
import { ReassignKamDialogComponent } from '../../dialog/reassign-kam-dialog/reassign-kam-dialog.component';

@Component({
  selector: 'app-orphan-municipality',
  templateUrl: './orphan-municipality.component.html',
  styleUrls: ['./orphan-municipality.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrphanMunicipalityComponent {
  @Input() municipalities: MunicipalityView[] = [];
  @Output() refresh = new EventEmitter();

  constructor(private matDialog: MatDialog) {}

  edit(municipality: MunicipalityView) {
    if (!municipality.isOrphan && isNil(municipality.primaryAdminGuid)) {
      this.assignKam(municipality);
      return;
    }

    this.matDialog
      .open(OrphanMunicipalityDialogComponent, {
        panelClass: ['-md', 'orphan-municipality'],
        data: {
          municipality: municipality,
        },
      })
      .afterClosed()
      .subscribe((refresh) => {
        if (refresh) {
          this.refresh.emit();
          this.matDialog.open(NotificationDialogComponent, {
            data: {
              descriptionText: 'Regionenzuordnung erfolgreich',
              descriptionFaClass: 'fa-check-circle fa-2x',
              descriptionFaColor: cssVariables['--confirm-success-color'],
              hideClose: true,
              closeButton: true,
            },
            panelClass: ['-md'],
          });
        }

        if (refresh === null) {
          this.matDialog.open(NotificationDialogComponent, {
            data: {
              descriptionText: 'Region assignment Failed. Please try again later.',
              descriptionFaClass: 'fa-exclamation-triangle fa-3x',
              descriptionFaColor: cssVariables['--ep-error-color'],
            },
            panelClass: ['-md'],
          });
        }
      });
  }

  assignKam(data: MunicipalityView) {
    this.matDialog
      .open(ReassignKamDialogComponent, {
        data: {
          municipalityGuid: data.guid,
          municipalityName: data.municipalityName,
          municipalityKey: data.municipalityKey,
        },
        panelClass: ['-md'],
      })
      .afterClosed()
      .subscribe((success) => {
        if (success) {
          this.showReassignSuccess()
            .afterClosed()
            .subscribe(() => this.refresh.emit());
        }
      });
  }

  showReassignSuccess() {
    return this.matDialog.open(NotificationDialogComponent, {
      data: {
        descriptionText: 'KAM-Zuordnung erfolgreich',
        descriptionFaClass: 'fa-check-circle fa-2x',
        descriptionFaColor: cssVariables['--confirm-success-color'],
        hideClose: true,
      },
      panelClass: ['-md'],
    });
  }

  trackByFn(_: number, item: any) {
    return item.municipalityId;
  }
}
